import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationInsightsService } from '../app-insights-service/app-insights.service';

@Injectable({
    providedIn: 'root'
  })
export class ApplicationInsightsErrorHandler extends ErrorHandler {

  constructor(private appInsights: ApplicationInsightsService) {
    super();
  }

  public handleError(error: any): void {
    this.appInsights.logException(error);
    ErrorHandler.prototype.handleError.call(this, error);
  }
}
